var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMoney2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E1CDF5E9-7238-4383-AF3A-D3988FF486D0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-364.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money-2",
    transform: "translate(364.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,21.25 C3.3499999,21.25 1.25,19.1500001 1.25,15.5 L1.25,8.5 C1.25,4.8499999 3.3499999,2.75 7,2.75 L17,2.75 C20.6500001,2.75 22.75,4.8499999 22.75,8.5 L22.75,15.5 C22.75,19.1500001 20.6500001,21.25 17,21.25 L7,21.25 Z M2.75,8.5 L2.75,15.5 C2.75,18.3599999 4.1400001,19.75 7,19.75 L17,19.75 C19.8599999,19.75 21.25,18.3599999 21.25,15.5 L21.25,8.5 C21.25,5.6400001 19.8599999,4.25 17,4.25 L7,4.25 C4.1400001,4.25 2.75,5.6400001 2.75,8.5 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,12 C8.25,9.93000007 9.93000007,8.25 12,8.25 C14.0699999,8.25 15.75,9.93000007 15.75,12 C15.75,14.0699999 14.0699999,15.75 12,15.75 C9.93000007,15.75 8.25,14.0699999 8.25,12 Z M9.75,12 C9.75,13.24 10.76,14.25 12,14.25 C13.24,14.25 14.25,13.24 14.25,12 C14.25,10.76 13.24,9.75 12,9.75 C10.76,9.75 9.75,10.76 9.75,12 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9.75 C1.59,9.75 1.25,9.41 1.25,9 C1.25,8.59 1.59,8.25 2,8.25 L3,8.25 C5.57999992,8.25 6.25,7.57999992 6.25,5 L6.25,4 C6.25,3.59 6.59,3.25 7,3.25 C7.41,3.25 7.75,3.59 7.75,4 L7.75,5 C7.75,8.42000008 6.42000008,9.75 3,9.75 L2,9.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,9.75 C17.5799999,9.75 16.25,8.42000008 16.25,5 L16.25,4 C16.25,3.59 16.59,3.25 17,3.25 C17.41,3.25 17.75,3.59 17.75,4 L17.75,5 C17.75,7.57999992 18.4200001,8.25 21,8.25 L22,8.25 C22.41,8.25 22.75,8.59 22.75,9 C22.75,9.41 22.41,9.75 22,9.75 L21,9.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,20 L6.25,19 C6.25,16.4200001 5.57999992,15.75 3,15.75 L2,15.75 C1.59,15.75 1.25,15.41 1.25,15 C1.25,14.59 1.59,14.25 2,14.25 L3,14.25 C6.42000008,14.25 7.75,15.5799999 7.75,19 L7.75,20 C7.75,20.41 7.41,20.75 7,20.75 C6.59,20.75 6.25,20.41 6.25,20 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,20 L16.25,19 C16.25,15.5799999 17.5799999,14.25 21,14.25 L22,14.25 C22.41,14.25 22.75,14.59 22.75,15 C22.75,15.41 22.41,15.75 22,15.75 L21,15.75 C18.4200001,15.75 17.75,16.4200001 17.75,19 L17.75,20 C17.75,20.41 17.41,20.75 17,20.75 C16.59,20.75 16.25,20.41 16.25,20 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMoney2);
export default __webpack_public_path__ + "static/media/vuesax-outline-money-2.5def9105bfe7367c83e55210e9b9d164.svg";
export { ForwardRef as ReactComponent };